import React from 'react'
import { Field } from 'redux-form'

// scss Validators from 'app/utils/Validators'
import InputFieldComponent from '../component/InputFieldComponent'

// const { emptyValidator } = Validators

const CityField = ({ placeholder }) => (
  <Field
    name="city"
    placeholder={placeholder}
    component={InputFieldComponent}
    // validate={[emptyValidator]}
  />
)

export default CityField
